export const TemplateFieldsReportsClevelHeatmap = [
  {
    type: 'dropdownstatus',
    settings: {
      directionField: 'technical'
    },
    calculations: [ 'time', 'cost', 'quality', 'organizational' ]
  }
];
